<template>
  <div>
    <Modal
      :title="modalTitle"
      :saving="saving"
      @hide-modal="$emit('hide-modal')"
      @submit="handleSave"
    >
      <CustomerMembershipForm ref="form" :membership="membership" />
      <template #delete>
        <Button
          v-if="membership.membership_delete_url"
          type="danger"
          @click="confirm = true"
        >
          <span>Delete</span>
        </Button>
      </template>
    </Modal>
    <Modal
      title="Delete Membership"
      :open="confirm"
      @hide-modal="toggleConfirm"
    >
      <div>Are you sure you want to delete this customers membership?</div>
      <template #submit>
        <Button type="danger" @click="handleDelete">
          <Spinner v-if="deleting" message="Deleting..." />
          <span v-else>Delete</span>
        </Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import Spinner from "@/components/Spinner.vue";
import CustomerMembershipForm from "./CustomerMembershipForm.vue";

export default {
  components: {
    Spinner,
    Modal,
    CustomerMembershipForm,
    Button
  },
  props: {
    membership: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["action-success", "hide-modal"],
  data() {
    return {
      saving: false,
      deleting: false,
      confirm: false
    };
  },
  computed: {
    ...mapState(["currentUser"]),
    modalTitle() {
      return this.membership.membership_id
        ? "Edit Membership"
        : "Add Membership";
    }
  },
  mounted() {
    this.fetchMembershipPrograms();
  },
  methods: {
    ...mapActions([
      "fetchMembershipPrograms",
      "updateCustomerMembership",
      "createCustomerMembership",
      "deleteCustomerMembership"
    ]),
    handleSave() {
      this.$refs.form.getFormData().then((formData) => {
        this.handleAction({
          customerId: this.currentUser.id,
          data: { membership: formData }
        });
      });
    },
    handleDelete() {
      this.deleting = true;
      this.deleteCustomerMembership({
        url: this.membership.membership_delete_url
      })
        .then(() => {
          this.$emit("action-success");
          window.notify.success("Membership deleted successfully!");
          this.$emit("hide-modal");
        })
        .finally(() => (this.deleting = false));
    },
    handleAction(payload) {
      this.saving = true;
      let membershipAction = this.createCustomerMembership;
      let action = "created";

      if (payload.data.membership.membership_id) {
        membershipAction = this.updateCustomerMembership;
        action = "updated";
        payload.url = this.membership.membership_update_url;
      }

      membershipAction(payload)
        .then(() => {
          this.$emit("action-success");
          window.notify.success(`Membership ${action} successfully!`);
          this.$emit("hide-modal");
        })
        .finally(() => (this.saving = false));
    },
    onDelete() {
      this.toggleConfirm();
    },
    toggleConfirm() {
      this.confirm = !this.confirm;
    }
  }
};
</script>

<style lang="scss" scoped></style>
